import { supabase } from './supabase'
import { profitabilityRows } from './jobProfitability.mjs'
export async function readProfitability(scope) {
  if (!scope.owner) throw new Error('Owner access required.')
  const { data: { session } } = await supabase.auth.getSession()
  if (!session || session.user?.id !== scope.actorId) throw new Error('Sign in again to continue.')
  const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 20000)
  try {
    const response = await fetch('/.netlify/functions/job-profitability', { method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` }, body: JSON.stringify({ workshop_id: scope.workshopId }) })
    if (!response.ok || !/^application\/json\b/i.test(response.headers.get('content-type') || '')) throw new Error()
    const text = await response.text()
    if (new Blob([text]).size > 4 * 1024 * 1024) throw new Error()
    const { data } = JSON.parse(text)
    profitabilityRows(data, scope.workshopId)
    profitabilityRows(data, scope.workshopId, 'actual_payroll')
    return data
  } catch { throw new Error('Complete profitability evidence could not be loaded. Refresh to try again.') }
  finally { clearTimeout(timeout) }
}
